module.exports = __webpack_public_path__ + "img/dlGDEJur.1b72fd98.svg";